// Components==============
import { MenuContext } from 'components/Layout/Menu/Menu';
import { motion } from 'framer-motion';
import React, { useContext } from 'react';
import './Modal.module.scss';
// =========================

export default function Modal({
    children,
    setModalIsOpen,
}: {
    children: React.ReactNode;
    setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
    const { setActiveLogForDeleteModal } = useContext(MenuContext);

    return (
        <motion.div
            styleName="wrapper"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div styleName="content">{children}</div>
            <div
                styleName="shader"
                onClick={() => {
                    if (setActiveLogForDeleteModal)
                        return setActiveLogForDeleteModal(undefined);

                    setModalIsOpen(false);
                }}
            />
        </motion.div>
    );
}
